import { InjectionToken } from '@angular/core';

export const PAYU_SDK_URL = new InjectionToken<string>('PAYU_SDK_URL');
